import { Component } from 'react';

import { type TableRowProps } from '@material-ui/core/TableRow'

import { TableBodyAsRowFragmentStyled } from './styles/TableBodyAsRowFragmentStyled'

export class TableBodyAsRowFragment extends Component<TableRowProps> {
  render() {
    return (
      <TableBodyAsRowFragmentStyled>
        {this.props.children}
      </TableBodyAsRowFragmentStyled>
    )
  }
}
